import { render } from "./PasswordInput.vue?vue&type=template&id=a64d9b08&scoped=true"
import script from "./PasswordInput.vue?vue&type=script&lang=js"
export * from "./PasswordInput.vue?vue&type=script&lang=js"

import "./PasswordInput.vue?vue&type=style&index=0&id=a64d9b08&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a64d9b08"]])

export default __exports__